


























































import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default defineComponent({
  name: 'uOttawa1321Lab2TLCPlate',
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        language: 'en',
        SampleCalc: null,
      },
      TlcPlate: [] as File[],
      questions: [
        {
          en: 'Please use the upload field below to upload the drawing of your TLC plate for the experiment.',
          fr: "Veuillez utiliser le champ de téléchargement ci-dessous pour télécharger le dessin de votre plaque de CCM pour l'expérience.",
        },
      ],
    };
  },
  methods: {
    getQuestionText(question: any): string {
      return this.inputs.language === 'en' ? question.en : question.fr;
    },
  },
  computed: {
    attachments(): File[] {
      return [...this.TlcPlate];
    },
  },
});
